import React from 'react'
import { usePowerFactor } from '../../hooks'
import MetricCard from '../../../../common/components/atom/MetricCard/MetricCard'
import { PowerFactorIcon } from '../../../../common/components/atom/MetricCard/icons'

export default function LastPowerFactorPresenter() {
  const { lastPowerFactorQuery } = usePowerFactor()

  if (lastPowerFactorQuery.isLoading) {
    return (
      <MetricCard
        title="Facteur de Puissance"
        value="..."
        unit=""
        percentage={0}
        range="0-1"
        icon={<PowerFactorIcon />}
        color="orange"
      />
    )
  }

  if (lastPowerFactorQuery.isError || !lastPowerFactorQuery.data || lastPowerFactorQuery.data.length === 0) {
    return (
      <MetricCard
        title="Facteur de Puissance"
        value="N/A"
        unit=""
        percentage={0}
        range="0-1"
        icon={<PowerFactorIcon />}
        color="orange"
      />
    )
  }

  // Récupérer la dernière valeur
  const lastValue = lastPowerFactorQuery.data[0]
  const value = lastValue?.Value || 0
  const percentage = Math.round(value * 100)

  return (
    <MetricCard
      title="Facteur de Puissance"
      value={value.toFixed(2)}
      unit=""
      percentage={percentage}
      range="0-1"
      icon={<PowerFactorIcon />}
      color="orange"
    />
  )
}
